<template>
  <div :class="{'grid grid-flow-col grid-rows-1 gap-2 items-center': inline}">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <div v-if="prefix" class="mt-1 relative rounded-md shadow-sm">
      <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none z-10 text-gray-600">{{ prefix }}</div>
      <input :id="id" ref="input" v-bind="$attrs" class="form-input block w-full pl-16 sm:pl-14" :class="{ error: errors.length }" :type="type" :value="value" @change="$emit('change', $event.target.value)" @input="$emit('input', $event.target.value)">
    </div>
    <input v-else  :id="id" ref="input" v-bind="$attrs" class="form-input" :class="{ error: errors.length }" :type="type" :value="value" @change="$emit('change', $event.target.value)" @input="$emit('input', $event.target.value)">
    <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${this._uid}`
      },
    },
    prefix: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'text',
    },
    value: String|Number,
    label: String,
    errors: {
      type: Array,
      default: () => [],
    },
    inline: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
  },
}
</script>
